/******************************************************************************************
 *	Download CSV Directive
 ******************************************************************************************/
(function() {
  

  angular.module('rcDirectives.rcDownloadCsv', []).directive(
    'rcDownloadCsv',
    /* @ngInject */
    function(_, $log, csvUtils, CurtainNotifications, Customers, DemoMode, downloadUtils, Payload) {
      return {
        restrict: 'A',
        scope: {
          segmentPath: '@currentSegmentPath'
        },
        link: function(scope, element) {
          //Determine if the download can be triggered and the download button disabled state
          var canDownloadCsv = true;
          var allowDownload = function() {
            canDownloadCsv = true;
            element.prop('disabled', false);
          };
          var disallowDownload = function() {
            canDownloadCsv = false;
            element.prop('disabled', true);
          };

          var clickHandler = function() {
            if (DemoMode.isEnabled()) {
              //FR: TODO ~ Demo Mode
              $log.info('%cFunction blocked in DEMO MODE.', 'color:#CCCCCC;');
              return;
            } else if (!canDownloadCsv) {
              return;
            }

            disallowDownload();

            Customers.getCsvData(scope.segmentPath, Payload.get())
              .then(responseData => csvUtils.convertTsvToCsv(responseData.file))
              .then(csvData => {
                // Trigger file download
                downloadUtils.downloadExportData(csvData, `customers-${scope.segmentPath}.csv`);
              })
              .catch((response) => {
                CurtainNotifications.show(
                  CurtainNotifications.ERROR,
                  'customersList.notifications.csvCannotDownload'
                );
                $log.error('Failed to download customer list CSV', response.data);
              })
              .finally(() => {
                allowDownload();
              });
          };

          element.on('click', clickHandler);

          //Clean-up
          scope.$on('$destroy', function() {
            element.off('click', clickHandler);
          });
        }
      };
    }
  );
})();
